import React, { FC } from 'react';
import { Container, Row } from 'react-bootstrap';
import ClTitle from 'components/clientComp/clTitle';
import {
  ClBackendExp,
  ClFrontendExp,
} from 'components/clientComp/clExperience/components';

import './ClExperience.scss';

const ClExperience: FC = () => {
  return (
    <Container fluid className="cl-exp">
      <ClTitle
        titleNumber={'02'}
        title={'My Experience'}
        subTitle={'What Skills I Have'}
      />
      <Row className="cl-exp-container">
        <div
          data-aos="fade-left"
          data-aos-duration="1000"
          className="cl-exp-left"
        >
          <ClFrontendExp />
        </div>
        <div
          data-aos="fade-right"
          data-aos-duration="1000"
          className="cl-exp-right"
        >
          <ClBackendExp />
        </div>
      </Row>
    </Container>
  );
};

export default ClExperience;
